import React from "react";
import ErrorBoundary from "./Components/ErrorBoundary/errorBoundary";
import AppRoutes from "./route";

const App = () => {
  return (
    <ErrorBoundary>
      <AppRoutes />
    </ErrorBoundary>
  );
};

export default App;
